import { createSlice } from '@reduxjs/toolkit';

export interface ProjectManagementState {
  triggerReloadGetListProject: boolean;
  currentSelectedProject: any;
  projectDetailRoles: any;
  isUpdateProjectRoleManagement: boolean;
  isUpdateProjectManagement: boolean;
  listTypePJ: any;
  envDeatil: any;
  isUpdateEnv: boolean;
  modeEnv: string;
}

const initialState: ProjectManagementState = {
  triggerReloadGetListProject: false,
  currentSelectedProject: null,
  projectDetailRoles: null,
  isUpdateProjectRoleManagement: false,
  isUpdateProjectManagement: false,
  listTypePJ: [],
  envDeatil: [],
  isUpdateEnv: false,
  modeEnv: '',
};

export const projectManagementSlice = createSlice({
  name: 'ProjectManagement',
  initialState,
  reducers: {
    setTriggerReloadGetListProject: (state, action) => {
      state.triggerReloadGetListProject = action.payload;
    },
    setCurrentSelectedProject: (state, action) => {
      state.currentSelectedProject = action.payload;
    },
    setProjectDetailRoles: (state, action) => {
      state.projectDetailRoles = action.payload;
    },
    setisUpdateProjectRoleManagement: state => {
      state.isUpdateProjectRoleManagement = !state.isUpdateProjectRoleManagement;
    },
    setisUpdateProjectManagement: state => {
      state.isUpdateProjectManagement = !state.isUpdateProjectManagement;
    },
    setListTypePJ: (state, action) => {
      state.listTypePJ = action.payload;
    },
    setEnvDeatil: (state, action) => {
      state.envDeatil = action.payload;
    },
    setIsUpdateEnv: state => {
      state.isUpdateEnv = !state.isUpdateEnv;
    },
    setModeEnv: (state, action) => {
      state.modeEnv = action.payload;
    },
  },
  extraReducers: builder => {},
});

export const {
  setTriggerReloadGetListProject,
  setCurrentSelectedProject,
  setProjectDetailRoles,
  setisUpdateProjectRoleManagement,
  setisUpdateProjectManagement,
  setListTypePJ,
  setEnvDeatil,
  setIsUpdateEnv,
  setModeEnv,
} = projectManagementSlice.actions;
export default projectManagementSlice.reducer;
